import { Button, Stack } from '@chakra-ui/react';
import { Link } from '@chakra-ui/next-js';
import { FaFilePdf, FaFile } from 'react-icons/fa';
import { MdDownload } from 'react-icons/md';
import { getFileUrl } from '~/lib/providers/vitec/file';
import { CommonEstateDocument } from '@habity/types/vitec/common/commonEstateDocument';
import { formatDistance } from 'date-fns';
import { sv } from 'date-fns/locale';
import { ActionRow } from '../ActionRow';
import { useTranslations } from 'next-intl';
import { useAgency } from '~/hooks/useAgency';

type FileType = {
  name: string;
  icon: TODO;
};

const getFileType = (extension?: string): FileType => {
  switch (extension) {
    case '.pdf':
      return { name: 'PDF', icon: FaFilePdf };
    default:
      return { name: 'Dokument', icon: FaFile };
  }
};

export const Documents = ({
  documents,
}: {
  documents: CommonEstateDocument[];
}) => {
  const t = useTranslations('HomeProfile.Accordions.Documents');
  const { agency } = useAgency();
  return (
    <Stack spacing="6" py="4">
      {documents &&
        documents.map((document, index) => (
          <ActionRow
            index={index}
            key={index}
            icon={getFileType(document.extension).icon}
            name={document.name || ''}
            button={
              document.id && agency?.id ? (
                <Link href={getFileUrl(document.id, agency.id)} target="_blank">
                  <Button
                    size="sm"
                    as={Button}
                    leftIcon={<MdDownload />}
                    variant="secondary"
                    fontSize="sm"
                  >
                    {t('Buttons.download')}
                  </Button>
                </Link>
              ) : null
            }
          />
        ))}
    </Stack>
  );
};
